import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ElanCard from '../../components/ElanCard';
import ElanController from '../../api/elan/ElanController'; // ElanController'ı import et
import './Elanlar.css';
import Loader from '../../components/Loader'; // Loader komponentini import edirik
import LotoreyaController from '../../api/lotoreya/LotoreyaController';

const Elanlar = () => {
  const { category } = useParams();  // URL-dən kateqoriyanı alırıq
  const [filteredElans, setFilteredElans] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // initially set to true
  const [lotoreyas, setLotoreyas] = useState([]);

  const navigate = useNavigate();  // Initialize useNavigate

  useEffect(() => {
    const loadElans = async () => {
      try {
        const response = await ElanController.getAllElans();

        // Lotoreyaları da yüklə
        const lotoreyaResponse = await LotoreyaController.getAllLotoreyas();
        setLotoreyas(lotoreyaResponse); // saxlayırıq

        // Filter kateqoriyaya görə
        const categoryElans = response.filter(elan => elan.category === category);

        // Premium və normal ayır
        const premiumElans = categoryElans.filter(elan => elan.premium === true);
        const normalElans = categoryElans.filter(elan => !elan.premium);

        premiumElans.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        normalElans.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        const allSortedElans = [...premiumElans, ...normalElans];

        setFilteredElans(allSortedElans);

        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      } catch (error) {
        console.error('Elanlar və ya Lotoreya yüklənərkən xəta:', error);
      }
    };

    loadElans();
  }, [category]);

  // Kateqoriya başlığını təyin etmək üçün
  const getCategoryTitle = (category) => {
    switch (category) {
      case 'taxi':
        return 'Moto Taksi Elanları';
      case 'sales':
        return 'Moto Alqı-Satqı Elanları';
      case 'rent':
        return 'Moto Kirayə Elanları';
      case 'spare':
        return 'Moto Zapçast Elanları';
      default:
        return 'Elanlar';
    }
  };

  // Handle the click event on the ElanCard
  const handleElanClick = (elanId) => {
    navigate(`/elan/${elanId}`);  // Navigate to the individual Elan page with the ID
  };

  return (
    <div className="elanlar-container">
      <h2 className="section-title">{getCategoryTitle(category)}</h2> {/* Kateqoriya başlığını göstəririk */}

      <div className="elans-container">
        {isLoading ? (
          <Loader />
        ) : (
          filteredElans.map((elan, index) => {
            // Elanın lotoreyada olub-olmamasını yoxlayırıq:
            const matchingLotoreya = lotoreyas.find(l => l.elanId === elan.id);

            let lotoreyaStatus = null;
            if (matchingLotoreya) {
              if (matchingLotoreya.carx == null) {
                lotoreyaStatus = matchingLotoreya.isAccept ? 'accepted' : 'pending';
              } else {
                lotoreyaStatus = null; // Lotoreya artıq başa çatıbsa heç nə göstərilmir
              }
            }


            return (
              <ElanCard
                key={index}
                {...elan}
                title={
                  elan.title.length > 25
                    ? elan.title.slice(0, 25) + '...'
                    : elan.title
                }
                description={
                  elan.description.length > 30
                    ? elan.description.slice(0, 30) + '...'
                    : elan.description
                }
                lotoreyaStatus={lotoreyaStatus} // <== Prop kimi veririk
                onClick={() => handleElanClick(elan.id)}
              />
            );
          })

        )}
      </div>
    </div>
  );
};

export default Elanlar;

